import * as React from "react";
import type { SVGProps } from "react";
const SvgCopyRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="M6 14.4H3.6a1.2 1.2 0 0 1-1.2-1.2V4.4a2 2 0 0 1 2-2h8.8a1.2 1.2 0 0 1 1.2 1.2V6M12 21.6h7.2a2.4 2.4 0 0 0 2.4-2.4V12a2.4 2.4 0 0 0-2.4-2.4H12A2.4 2.4 0 0 0 9.6 12v7.2a2.4 2.4 0 0 0 2.4 2.4Z"
    />
  </svg>
);
export default SvgCopyRight;
